export default __webpack_public_path__ + "assets/874953e98455b89d24466adad183579d.svg";